import { render, staticRenderFns } from "./AutoInvest.vue?vue&type=template&id=21a82982&scoped=true&"
import script from "./AutoInvest.vue?vue&type=script&lang=js&"
export * from "./AutoInvest.vue?vue&type=script&lang=js&"
import style0 from "./AutoInvest.vue?vue&type=style&index=0&id=21a82982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a82982",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
